(function ($) {
    $(window).on('load', function() {

		/* Get DOM elements */
		let modal = $("#modal");
		let closeBtn = $("#modalCloseBtn");
		let overlay = $('#overlay');

		/* Close modal */
		let closeModal = function() {
			modal.removeAttr("style");
			overlay.removeAttr("style");
			localStorage.setItem("modal_closed", "true");
		}

		/* Showing modal after 0,5 sec */
		setTimeout(() => {
			if( ! localStorage.getItem("modal_closed") ) {
				modal.show();
				overlay.show();
			}
		}, 500);

		/* Actions that closing modal */
		closeBtn.on('click', function(){
			closeModal();
		});
		overlay.on('click', function(){
			closeModal();
		});

    });
})(jQuery);
